module.exports = __webpack_public_path__ + "img/introduce-icon4.5b038871.svg";